import { useContext } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import { Link } from "react-router-dom";
import "./EnhDosyaIncelemesi.css";

export default function EnhDosyaBilgileri() {
  const {
    kurumlar,
    evrakList,
    setEvrakList,
    //EMLAK BEYAN VERİLERİ
    emlakBeyani,
    setEmlakBeyani,
    emlakBeyaniEvraki,
    setEmlakBeyaniEvraki,
    //ÖNCEKİ DEĞERLEMELER
    oncekidegerlemevarmi,
    setoncekidegerlemevarmi,
    oncekidegerleme,
    setoncekidegerleme,
  } = useContext(GlobalContext);

  const emlakBeyaniEvrakiChange = (e) => {
    const { name, value } = e.target;
    setEmlakBeyaniEvraki((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    console.log(emlakBeyaniEvraki);
  };

  const oncekidegerlemeChange = (e) => {
    const { name, value } = e.target;
    setoncekidegerleme((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    console.log(oncekidegerleme);
  };
  const oncekidegerlemeYok = () => {
    setoncekidegerlemevarmi(false);
    setoncekidegerleme(false);
  };
  const oncekidegerlemeVar = () => {
    setoncekidegerlemevarmi(true);
  };

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...evrakList];
    list[index][name] = value;
    setEvrakList(list);

    console.log(list);
  };

  const emlakBeyaniYok = () => {
    setEmlakBeyani(false);
    setEmlakBeyaniEvraki(false);
  };
  const emlakBeyaniVar = () => {
    setEmlakBeyani(true);
  };
  const handleServiceRemove = (index) => {
    const list = [...evrakList];
    list.splice(index, 1);
    setEvrakList(list);
  };

  const handleServiceAdd = () => {
    setEvrakList([
      ...evrakList,
      { kurum: "", tarih: "", evrakno: "", evrakinOzu: "" },
    ]);
  };

  return (
    <GlobalProvider>
      <div className="container">
        <div className="row">
          <h1 className="text-center my-3">
            Dava Dosyasında Değerleme İçin Gerekli Evrakların İncelenmesi{" "}
          </h1>
        </div>
        <div className="row my-3">
          <h3>
            Taşınmazın arazi olduğunu bildiren evrakların geldiği kurum, tarih
            ve evrak sayılarını yazınız (İlk Evrak Belediye Emlak Beyan Evrakı
            olmalıdır)
          </h3>
        </div>
        <div className="row">
          <div className="col mt-1 mb-2 mx-2">
            {evrakList.map((evrak, index) => (
              <div
                key={index}
                className="row border border-primary rounded mt-2"
              >
                <div className="col my-1">
                  <div className="input-group">
                    <span className="input-group-text bg-primary">
                      {index + 1}
                    </span>
                    <select
                      name="kurum"
                      onChange={(e) => handleServiceChange(e, index)}
                      className="form-control"
                      value={evrakList[index].kurum}
                    >
                      <option>--Seçiniz--</option>
                      {kurumlar.map((kurum, index) => (
                        <option key={index}>{kurum.name}</option>
                      ))}
                    </select>

                    <input
                      name="tarih"
                      type="date"
                      max={"2024-12-31"}
                      id="tarih"
                      className="form-control mx-2"
                      value={evrak.tarih}
                      onChange={(e) => handleServiceChange(e, index)}
                      required
                    />

                    <input
                      name="evrakno"
                      type="text"
                      id="evrakno"
                      className="form-control mx-2"
                      value={evrak.evrakno}
                      onChange={(e) => handleServiceChange(e, index)}
                      placeholder="evrak sayısı"
                      required
                    />
                    {/* <textarea
                      name="evrakinOzu"
                      type="text"
                      id="evrakinOzu"
                      className="form-control mx-2"
                      value={evrak.evrakinOzu}
                      onChange={(e) => handleServiceChange(e, index)}
                      placeholder="evrakın özeti"
                      required
                    /> */}

                    {evrakList.length - 1 === index && evrakList.length < 6 && (
                      <button
                        type="button"
                        onClick={handleServiceAdd}
                        className="btn btn-primary"
                      >
                        <span>Evrak Ekle</span>
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-2 my-1">
                  {evrakList.length !== 1 && (
                    <button
                      type="button"
                      onClick={() => handleServiceRemove(index)}
                      className="btn btn-danger"
                    >
                      <span>Sil</span>
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="row mt-5">
          <div className="form-check">
            <input
              className="form-check-input "
              type="radio"
              name="emlakBeyanDurumu"
              id="beyanYok"
              checked={emlakBeyani === false ? true : false}
              onChange={() => emlakBeyaniYok()}
            />
            <label className="form-check-label text-danger" htmlFor="beyanYok">
              Dava dosyasında emlak beyan değeri <b>YOKTUR.</b>
            </label>
          </div>
          <div className="form-check mb-5">
            <input
              className="form-check-input"
              type="radio"
              name="emlakBeyanDurumu"
              id="beyanVar"
              checked={emlakBeyani === true ? true : false}
              onChange={() => emlakBeyaniVar()}
            />
            <label className="form-check-label" htmlFor="beyanVar">
              Dava dosyasında emlak beyan değeri <b>VARDIR.</b>
            </label>
          </div>

          {/* EMLAK BEYAN EVRAKI EKLEME */}
          <div className="row mt-5">
            {emlakBeyani && (
              <div className="row border border-primary rounded mt-2">
                <h3>EMLAK BEYAN DEĞERİ EVRAKININ BİLGİLERİNİ GİRİNİZ</h3>
                <div className="col my-1">
                  <div className="input-group">
                    <span className="input-group-text bg-primary"></span>
                    <select
                      name="emlakbeyankurum"
                      id="emlakbeyankurum"
                      onChange={(e) => emlakBeyaniEvrakiChange(e)}
                      className="form-control"
                      value={
                        emlakBeyani ? emlakBeyaniEvraki.emlakbeyankurum : ""
                      }
                    >
                      <option>--Kurum Seçiniz--</option>
                      {kurumlar.map((kurum, index) => (
                        <option key={index}>{kurum.name}</option>
                      ))}
                    </select>

                    <input
                      name="emlakbeyantarih"
                      type="date"
                      max={"2025-12-31"}
                      id="emlakbeyantarih"
                      className="form-control mx-2"
                      onChange={(e) => emlakBeyaniEvrakiChange(e)}
                      value={
                        emlakBeyani ? emlakBeyaniEvraki.emlakbeyantarih : ""
                      }
                    />

                    <input
                      name="emlakbeyanevrakno"
                      type="text"
                      id="emlakbeyanevrakno"
                      className="form-control mx-2"
                      onChange={(e) => emlakBeyaniEvrakiChange(e)}
                      placeholder="evrak sayısı"
                      value={
                        emlakBeyani ? emlakBeyaniEvraki.emlakbeyanevrakno : ""
                      }
                    />
                    <textarea
                      name="emlakbeyanevrakinOzu"
                      type="text"
                      id="emlakbeyanevrakinOzu"
                      className="form-control mx-2"
                      onChange={(e) => emlakBeyaniEvrakiChange(e)}
                      placeholder="m2 değeri"
                      value={
                        emlakBeyani
                          ? emlakBeyaniEvraki.emlakbeyanevrakinOzu
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/*ÖNCEKİ DEĞERLEME VAR/YOK */}
        <div className="row mt-5">
          <div className="form-check">
            <input
              className="form-check-input "
              type="radio"
              name="oncekidegerlemedurumu"
              id="degerlemeYok"
              checked={oncekidegerlemevarmi === false ? true : false}
              onChange={() => oncekidegerlemeYok()}
            />
            <label
              className="form-check-label text-danger"
              htmlFor="degerlemeYok"
            >
              Taşınmaz için Önceden Yapılmış Değerleme <b>YOKTUR.</b>
            </label>
          </div>
          <div className="form-check mb-5">
            <input
              className="form-check-input"
              type="radio"
              name="oncekidegerlemedurumu"
              id="degerlemeVar"
              checked={oncekidegerlemevarmi === true ? true : false}
              onChange={() => oncekidegerlemeVar()}
            />
            <label className="form-check-label" htmlFor="degerlemeVar">
              Taşınmaz için Önceden Yapılmış Değerleme <b>VARDIR.</b>
            </label>
          </div>

          {/*ÖNCEKİ DEĞERLEME EKLEME */}
          <div className="row mt-5">
            {oncekidegerlemevarmi && (
              <div className="row border border-primary rounded mt-2">
                <h3>ÖNCEDEN YAPILAN DEĞERLEME BİLGİLERİNİ GİRİNİZ</h3>
                <div className="col my-1">
                  <div className="input-group">
                    <span className="input-group-text bg-primary"></span>
                    <select
                      name="degerlemeyapankurum"
                      id="degerlemeyapankurum"
                      onChange={(e) => oncekidegerlemeChange(e)}
                      value={
                        oncekidegerlemeVar
                          ? oncekidegerleme.degerlemeyapankurum
                          : ""
                      }
                      className="form-control"
                    >
                      <option>--Kurum Seçiniz--</option>
                      {kurumlar.map((kurum, index) => (
                        <option key={index}>{kurum.name}</option>
                      ))}
                    </select>

                    <input
                      name="oncekidegerlemetarih"
                      type="date"
                      max={"2024-12-31"}
                      id="oncekidegerlemetarih"
                      className="form-control mx-2"
                      onChange={(e) => oncekidegerlemeChange(e)}
                      value={
                        oncekidegerlemeVar
                          ? oncekidegerleme.oncekidegerlemetarih
                          : ""
                      }
                    />

                    <input
                      name="oncekidegerlememetrekarefiyati"
                      type="text"
                      id="oncekidegerlememetrekarefiyati"
                      className="form-control mx-2"
                      onChange={(e) => oncekidegerlemeChange(e)}
                      placeholder="Önceki Değerlemede m2 fiyatı"
                      value={
                        oncekidegerlemeVar
                          ? oncekidegerleme.oncekidegerlememetrekarefiyati
                          : ""
                      }
                    />
                    {/*Burda KAldık*/}
                    <input
                      name="oncekidegerlemetoplamfiyat"
                      type="number"
                      id="oncekidegerlemetoplamfiyat"
                      className="form-control mx-2"
                      onChange={(e) => oncekidegerlemeChange(e)}
                      placeholder="Önc. Değ. Top. Fiyat İrt.+Pilon Yeri"
                      value={
                        oncekidegerlemeVar
                          ? oncekidegerleme.oncekidegerlemetoplamfiyat
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* NAVİGASYON SATIRI */}
        <div className="row">
          <div className="col-3">
            <div className="row">
              <Link to="/enhkesifbilgileri">
                <button className="btn btn-success btn-lg mt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                    />
                  </svg>{" "}
                  Keşif Bilgileri
                </button>
              </Link>
            </div>
          </div>
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <div className="row">
              {" "}
              <Link to="/enhmunavebeuygula">
                {" "}
                <button className="btn btn-primary btn-lg mt-5">
                  Münavebe ve Değerleme
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-right-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                    />
                  </svg>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </GlobalProvider>
  );
}
